import { useState } from "react";
import { Nav } from "react-bootstrap";
import { RiCoupon3Line } from "react-icons/ri";
import { TbReportAnalytics } from "react-icons/tb";
import { IoSettingsOutline } from "react-icons/io5";
import StoreAnalytics from "./StoreAnalytics/StoreAnalytics";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { GrAnalytics, GrOrderedList, GrUser } from "react-icons/gr";
import OrderManagement from "./StoreProductManagement/OrderManagement/CouponManagement";
import CouponManagement from "./StoreProductManagement/CouponManagement/CouponManagement";
import CustomerManagement from "./StoreProductManagement/CustomerManagement/CustomerManagement";
import StoreProductManagement from "./StoreProductManagement/StoreProductManagement/StoreProductManagement";
import StoreSettingsManagement from "./StoreProductManagement/StoreSettingsManagement/StoreSettingsManagement";

const MENU = [
  { icon: <GrAnalytics />, key: "analytics", label: "Analytics" },
  { icon: <GrOrderedList />, key: "orders", label: "Orders" },
  { icon: <GrUser />, key: "customers", label: "Customers" },
  { icon: <MdOutlineProductionQuantityLimits />, key: "products", label: "Products" },
  { icon: <RiCoupon3Line />, key: "coupons", label: "Coupons" },
  { icon: <TbReportAnalytics />, key: "reports", label: "Reports" },
  { icon: <IoSettingsOutline />, key: "settings", label: "Settings" },
];

const StoreManagement = () => {
  const [openModule, setOpenModule] = useState("analytics");

  return (
    <div className="w-100 hstack">
      <div
        style={{ height: "calc(100vh - 56px)", minWidth: 180 }}
        className="overflow-auto border-end"
      >
        <div className="p-3 pb-0">
          <h6>Store Management</h6>
        </div>
        <Nav className="flex-column p-2 gap-1">
          {MENU.map((item) => {
            const isActive = openModule === item.key;
            return (
              <Nav.Link
                key={item.key}
                title={item.label}
                onClick={() => setOpenModule(item.key)}
                className={`sidebar-link ${isActive ? "active" : ""}`}
              >
                <span className="icon" style={{ fontSize: 14 }}>
                  {item.icon}
                </span>
                <span className="label" style={{ fontSize: 14 }}>
                  {item.label}
                </span>
              </Nav.Link>
            );
          })}
        </Nav>
      </div>
      <div
        className="w-100 bg-light overflow-auto"
        style={{ height: "calc(100vh - 56px)" }}
      >
        {
          {
            analytics: <StoreAnalytics />,
            orders: <OrderManagement />,
            customers: <CustomerManagement/>,
            products: <StoreProductManagement />,
            coupons: <CouponManagement />,
            reports: <h5>Report Management</h5>,
            settings: <StoreSettingsManagement/>,
          }[openModule]
        }
      </div>
    </div>
  );
};

export default StoreManagement;
